module.exports = __webpack_public_path__ + "static/media/hero-image.67af8157.svg";